import Popup from 'reactjs-popup';
import Select from 'react-select'
import 'reactjs-popup/dist/index.css';
import React, { useEffect, useState } from 'react'
import { useAuthState } from '../../../../../../Helper/Context';
import { useDispatch } from 'react-redux';
import { EquipmentMasterPostDataAPI } from '../../../../../../Redux/WTPDashboardSlice/WTPDashboardsSlice/WTPMasterData/EquipmentMasterSlice';
import { WardNameDataDDL } from '../../../../../../Components/CommonDDL/WardNameDataDDL';
import { WTPEquipmentTypeDDLData } from '../../../../../../Components/CommonDDL/WTPEquipmentTypeDDLData';


export default function WTPEquipmentMasterPagePopup(props) {

    const { handleOnCloseClick, open, EditIcon, Flag, GardenMasterFlag, popupHeading, M_AssetTypeID, handleIsPost, apiFlag, rowData, HWard, WLable } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()
    const [IsOpen, setIsOpen] = useState(false)

    const [WtpEquipmentType, setWtpEquipmentType] = useState({
        DDL: [],
        ID: Flag === 'Update' ? rowData.m_wtP_EquipmentTypeID : 0,
        Label: Flag === 'Update' ? rowData.equipmentType : "Select...",
    })

    const [WardName, setWardName] = useState({
        DDL: [],
        ID: Flag === 'Update' ? rowData.m_WardID : 0,
        Label: Flag === 'Update' ? rowData.wardName : "Select...",
    })

    const [EquipmentTextField, setEquipmentTextField] = useState({
        equipmentDetails: Flag === 'Update' ? rowData.equipmentDetails : '',

    });

    const handleInputChange = (e) => {
        setEquipmentTextField({ ...EquipmentTextField, [e.target.name]: e.target.value })
    }


    const handlePost = () => {
        const data = {
            M_WTP_EquipmentMasterID: Flag === 'Update' ? rowData.m_wtP_EquipmentMasterID : '0',
            M_WardID: WardName.ID,
            M_WTP_EquipmentTypeID: WtpEquipmentType.ID,
            EquipmentDetails: EquipmentTextField.equipmentDetails,
            M_UserID: UserID,
            token: token,
            Flag: Flag === 'Update' ? 'Update' : 'Insert',
            handleIsPost: handleIsPost,
            handleOnCloseClick: handleOnCloseClick,
        }
        dispatch(EquipmentMasterPostDataAPI({ data }))

    }


    return (

        <Popup
            open={open} closeOnDocumentClick={false} onClose={handleOnCloseClick}
        >
            <div className="area_pop modal-dialog modal-dialog-scrollable modal-xl" style={{ alignItems: "center", justifyContent: 'center' }}>
                <div className="modal-content road_ward_modal">
                    <div className="modal-header pl-4 p-1">
                        <h4 className="modal-title" id="staticBackdropLabel">Equipment Master</h4>
                        <button onClick={handleOnCloseClick} className="btn-close m-1 mr-3" type="button" />
                    </div>
                    <div className="modal-body">
                        <div className='inner-modal-body'>
                            <div className="row details-row">
                                <div className="col-12 col-lg-6">
                                    <WardNameDataDDL
                                        WardName={WardName}
                                        setWardName={setWardName}
                                        rowData={rowData}
                                        Flag={Flag}
                                       
                                    />
                                </div>

                                <div className="col-12 col-lg-6">
                                    <WTPEquipmentTypeDDLData
                                        WtpEquipmentType={WtpEquipmentType}
                                        setWtpEquipmentType={setWtpEquipmentType}
                                        rowData={rowData}
                                        Flag={Flag}
                                    />
                                </div>
                                <div className="col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Equipment Name </b></label>
                                        <input type="text"
                                            className="form-control"
                                            id="equipmentDetails"
                                            aria-describedby="emailHelp"
                                            name='equipmentDetails'
                                            value={EquipmentTextField.equipmentDetails}
                                            onChange={(e) => handleInputChange(e)}
                                        />

                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-lg-12">
                                <div className="btn-action d-flex justify-content-end mt-lg-3">
                                    <button type='button'
                                        className="btn allBtn  float-right submit_btn"
                                        onClick={() => handlePost()}
                                    >{Flag === "Update" ? "Update" : "Save"} </button>
                                    <button type="button" className="btn addBtns cancel_btn ms-2 mr-2 mx-2  float-right" onClick={handleOnCloseClick} >Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* )} */}
        </Popup>
    )

}